function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.312 17.592c-.5 0-.899 0-1.298-.1-.7-.1-1.099-.8-.999-1.4.1-.7.7-1.1 1.398-1 .3 0 6.892 1 9.389-6.8 2.496-7.9 9.088-8.8 12.184-8.1.7.1 1.099.8.999 1.5-.1.7-.8 1.1-1.498 1-.3-.1-6.792-1.3-9.289 6.4-2.297 6.8-7.49 8.5-10.886 8.5z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18"
  }, props), _ref);
};

export default SvgComponent;